import { render } from "./Matchmaker.vue?vue&type=template&id=a036b158&scoped=true"
import script from "./Matchmaker.vue?vue&type=script&lang=js"
export * from "./Matchmaker.vue?vue&type=script&lang=js"

import "./Matchmaker.vue?vue&type=style&index=0&id=a036b158&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3522\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a036b158"]])

export default __exports__